<template >

 <img class="print_back" src="../../assets/logo1.jpg" alt="">
 <div v-if="formdata3"  style="font-family: auto;" class="printc">
  <div style="display: flex;justify-content: space-between;border-bottom: 2px solid black; margin-bottom: 1rem;
  margin-top: 1.5rem;
    padding: 0 1rem;">
        <div >

        </div>
        <div style="text-align: center;margin-left: 3rem;"><img width="180px" src="../../assets/1211.jpg" alt="">
          </div>
    <div style="text-align: center;"><p style="font-size: 1.1rem;">الجمهورية اليمنية
        <br/>
الاتحاد العام لنقابات عمال اليمني
       <br/>
        النقابة العامة للعاملين بالنقل والمواصلات
        <br/>
         اللجنة لنقابية للنقل الثقيل والمتوسط والخفيف
        <br/>
        م/ حضرموت
    </p></div>

    </div>
   <div style="display: flex;
    justify-content: space-between;
    margin: 1rem;">
    <div style="border: 1px solid;
    padding: 10px;
    text-align: end;">
            <p style="margin: 0;margin-left: 5rem;">   {{formdata2.number_complaint}} رقم البلاغ </p>
            <p style="margin: 0;margin-left: 5rem;"> {{Simple_date}} التاريخ</p>
            <p style="margin: 0;margin-left: 5rem;"> اليوم {{day}} </p>
            <p style="margin: 0;margin-left: 5rem;"> {{date.getHours()}}:{{date.getMinutes()}} الساعة</p>
        </div>
    
    <div style="display: flex; 
    align-items: center;
    justify-content: flex-end;
    flex-direction: row-reverse;">
     <p style="border: 1px solid;
    font-size: 1.5rem;
    padding: 1rem;"> بلاغ/شكوى</p>
           <div style="font-size: 1.5rem;
    margin-right: 2rem;">
           
          <span > عن</span> <span>{{formdata2.complaint_type_name}}</span> 
        </div>
           
        </div>
        
   </div>
    <table class="table table-striped" v-if="Presented[0]"> 
  <thead>
    <tr>
      <th rowspan="2"> ارقام التواصل</th>
            <th rowspan="2"> نوع العمل ومكانه</th>
            <th rowspan="2">  محل الاقامة</th>
            <th rowspan="2">  محافظة </th>
            <th rowspan="2">مديرية</th>
            <th rowspan="2">منطقة</th>
            <th rowspan="2">مقدم البلاغ/الشكوى</th>
            </tr>
  </thead>
  <tbody>

    <tr >
       
         <th >{{Presented[0].phone_1}}</th>
         <th >{{Presented[0].work}}</th>
         <th >{{Presented[0].residence_name}}</th>
         <th >{{formdata6.provinec_ar_name}}</th>
         <th >{{formdata6.name_ar }}</th> 
         <th >{{formdata4.name_ar}}</th>
         <th>{{ formdata2.presented }}</th>
    </tr>
    
  </tbody>
</table>


    <table class="table table-striped" v-if="Victims[0] || Accussed[0]">  
  <thead>
    <tr  >
      <th rowspan="2"> ملاحظات </th>
            <th rowspan="2">المستوى العليمي </th>
            <th rowspan="2"> العمل  </th>
            <th rowspan="2">  محل الاقامة</th>
            <th rowspan="2">  محل الميلاد </th>
            <th rowspan="2">الحالة</th> 
            <th rowspan="2">العمر</th>
            <th rowspan="2">الاسم</th>
            <th rowspan="2">م</th>
            <th rowspan="2">الطرف</th>
            </tr>
  </thead>
  <tbody>
    
    <tr v-for="(key,index) in Victims" :key="key.id">
       
         <th >{{key.note}}</th>
         <th >{{key.education_level_name}}</th>
         <th >{{key.work}}</th>
         <th >{{key.residence_name}}</th>
         <th >{{key.place_of_birth_name}}</th>
         <th > <span v-for="item in key.status_type_name" :key="item.id">
            {{item.status}},
         </span>
          </th>
         <th >{{key.age}}</th>
         <th >{{key.name}}</th>
         <th >{{index+1}}</th>
         <th >المجني عليهم</th>
    </tr>
   
    <tr v-for="key in Accussed" :key="key.id">
       
         <th >{{key.note}}</th>
         <th >{{key.education_level_name}}</th>
         <th >{{key.work}}</th>
         <th >{{key.residence_name}}</th>
         <th >{{key.place_of_birth_name}}</th>
         <th > <span v-for="item in key.status_type_name" :key="item.id">
            {{item.status}},
         </span>
          </th>
         <th >{{key.age}}</th>
         <th >{{key.name}}</th>
         <th >{{index+1}}</th>
         <th > المشكو بهم / المتهمين</th>
    </tr>
    
  </tbody>
</table>

<div  style="display: flex;
    justify-content: space-around;border: 1px solid;
    padding: 5px;
    margin: 2rem 1rem;">
    <span>بجانب {{formdata2.address}}</span><span> وحدة  {{formdata2.housing_box_name}}</span><span> في حي {{formdata2.district_name}}</span>
    <span>{{formdata2.tiem}} الوقت</span><span> {{formdata2.date}} التاريخ</span><span>:مكان وزمان وقوع الحادث/الجريمة</span>
    </div >
        <div style="display: flex;
    justify-content: space-between;
    margin: 0 4rem;"><span>المحترم بعد التحية</span><span>  /الاخ {{formdata2.clerk}}</span></div>
        <div >
          <p style="word-break: break-word;text-align:right;margin: 2rem 2rem;"> اتقدم اليكم ببلاغي هذا عن </p>
          <p style="word-break: break-word;text-align:right;margin: 2rem 2rem;"> {{formdata2.descr}}   </p>
          </div>

         <table class="table table-striped">
  <thead>
    <tr>
            
            <th rowspan="2">اجراءات قائد المركز </th>
            <th rowspan="2">رتبة مستلم البلاغ</th>
            <th rowspan="2">ظروف وكيفية استلام البلاغ</th>
            </tr>
  </thead>
  <tbody>
    
    <tr>
       
         <th >{{formdata2.complaint_procedures_name}}</th>
         <th >{{formdata2.clerk}}</th>
         <th >{{formdata2.complaint_recipient_name}}</th>
         
    </tr>

    
  </tbody>
</table>

   
        <br/>
        
       <div style="display: flex;justify-content: space-between;">
        <div style="display: flex;
    align-items: center;">

        </div>
        <div style="text-align: center;margin-left: 3rem;display: flex;
    align-items: center;"> 
        <p>الشرطة في خدمة الشعب</p>
          </div>
    <div style="text-align: end; padding-right: 1rem;">
      
<span> 774220772 - 715991480 : واتساب -</span>
       <br/>
<span> info@alatiqa.com : ايميل -</span>
  
        <br/>
<span> رقم الطوارىء 199 -</span>
   </div>

    </div> 
       
</div>
</template>

<script setup>
import { ref,onMounted, defineProps } from 'vue'
import  geturl  from "@/comp/geturl";
import { useRouter } from 'vue-router'
const router = useRouter()



const props = defineProps(['id'])
const formdata2 = ref(null)
const formdata3 = ref(null)
const formdata4 = ref(null)
const formdata5 = ref(null)
const formdata6 = ref(null)
const Presented = ref(null)
const Accussed = ref(null)
const Victims = ref(null)
const date = new Date()
const days =['الاحد',"الاثنين","الثلاثاء","الاربعاء","الخميس","الجمعه","السبت"]
const day = days[date.getDay()]
const dd = String(date.getDate()).padStart(2, '0')
const mm = String(date.getMonth()+1).padStart(2, '0')
const yyyy = date.getFullYear()
const Simple_date = mm + '/' + dd + '/' + yyyy
onMounted(()=>{
      
      
 // get complaints
        fetch(geturl()+"complaints/complaint/"+props.id+"/", {
        
        headers: {"Content-Type": "application/json"},
        })
        .then(res => res.json())
        .then(data => {formdata2.value = data

        fetch(geturl()+"district/"+formdata2.value.district+"/", {
        
        headers: {"Content-Type": "application/json"},
        })
        .then(res => res.json())
        .then(data => {formdata4.value = data
          
          fetch(geturl()+"city/"+formdata4.value.city+"/", {
        
        headers: {"Content-Type": "application/json"},
        })
        .then(res => res.json())
        .then(data => {formdata5.value = data

        fetch(geturl()+"directorate/"+formdata5.value.directorate+"/", {
        
        headers: {"Content-Type": "application/json"},
        })
        .then(res => res.json())
        .then(data => {formdata6.value = data
        })
        })

        })

        })
     

 // get complaints
        fetch(geturl()+"complaints/accused_and_victim/?complaint="+props.id, {
        
        headers: {"Content-Type": "application/json"},
        })
        .then(res => res.json())
        .then(data => {formdata3.value = data
        
        Presented.value = formdata3.value.filter((e) => {
        return e.party == 3
      })

        Victims.value = formdata3.value.filter((e) => {
        return e.party == 1
      })

        Accussed.value = formdata3.value.filter((e) => {
        return e.party == 2
      })
        })
})

</script>

<style scoped>
/*
:global(.side-con){
display: none !important
}
:global(nav){
display: none !important
}
:global(.flex){
display: block }

*/

			
			.print_back{
        position: absolute;
    z-index: -10;
    top: 50%;
    opacity: 0.4;
    left: 50%;
    transform: translate(-50%, -50%);
      }
      
</style>